import axios from "fetch-api/fetch-api";

export function deleteShoppingCartItemsApi(sku: string) {
  return axios.post<void>("/delete-shopping-cart-item-v3", { sku });
}
